import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static const VALID_SIZES = ["small", "large"];
static var validPriorities = ["primary", "secondary", "tertiary"];
static function toJSON() {
  return {
    disabled: this.disabled
  };
}
$ const {
  badgeAriaLabel,
  badgeNumber,
  href,
  priority = "none",
  partiallyDisabled,
  renderBody,
  size,
  transparent,
  type,
  class: inputClass,
  ...htmlInput
} = input;
$ input.toJSON = toJSON;
$ let tagType = "button";
$ let baseClassName = "icon-btn";
$ if (href) {
  tagType = "a";
  baseClassName = "icon-link";
}
<${tagType} ...processHtmlAttributes(htmlInput) onClick("handleClick") onKeydown("handleKeydown") onFocus("handleFocus") onBlur("handleBlur") href=href class=[inputClass, baseClassName, badgeNumber && `${baseClassName}--badged`, transparent && `${baseClassName}--transparent`, validPriorities.includes(priority) && `${baseClassName}--${priority}`, size && VALID_SIZES.includes(size) && `${baseClassName}--${size}`] data-ebayui type=(tagType === "button" && (type || "button")) aria-disabled=(partiallyDisabled && "true")>
  <${renderBody}/>
  <if(badgeNumber)>
    <ebay-badge number=badgeNumber type="icon" aria-label=badgeAriaLabel aria-hidden=(!!input.ariaLabel && "true")/>
  </if>
</>